<template>
    <el-drawer class="w-el-drawer" :visible.sync="visible" :size="960" :with-header="false" direction="rtl" :before-close="Close" append-to-body destroy-on-close>
        <div class="w-el-drawer-header">
            <i class="el-icon-tickets"></i> 新建合同
        </div>
        <div class="w-el-drawer-body" v-loading="loading">
            <el-form :model="form" label-width="120px" size="mini">
                <el-form-item label="关联商机">
                    <crm-business-select v-model="form.sale_documentary_id" @onChange="SaleDocumentaryOnChange" />
                </el-form-item>
                <el-form-item label="关联客户" :rules="[{ required: true, message: '必选项' }]" :error="formError.customer_id?.toString()" prop="customer_id">
                    <crm-customer-select v-model="form.customer_id" clearable />
                </el-form-item>
                <el-form-item label="合同名称" :rules="[{ required: true, message: '必填项' }]" :error="formError.name?.toString()" prop="name">
                    <el-input v-model="form.name" placeholder="X省X市XXxx项目" clearable />
                </el-form-item>
                <el-form-item label="合同编号" :rules="[{ required: true, message: '必填项' }]" :error="formError.number?.toString()" prop="number">
                    <el-input v-model="form.number" placeholder="CXXXXXX" clearable />
                </el-form-item>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="合同来源" :rules="[{ required: true, message: '必选项' }]" :error="formError.source_id?.toString()" prop="source_id">
                            <inputSource v-model="form.source_id"></inputSource>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同状态" :rules="[{ required: true, message: '必选项' }]" :error="formError.state?.toString()" prop="state">
                            <contract-state-select v-model="form.state" clearable />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="合同期限" :rules="[{ required: true, message: '必选项' }]" :error="formError.time_limit?.toString()" prop="time_limit">
                            <el-date-picker style="width: 100%;" v-model="form.time_limit" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="签单日期" :rules="[{ required: true, message: '必选项' }]" :error="formError.sign_date?.toString()" prop="sign_date">
                            <el-date-picker class="w-width-auto" v-model="form.sign_date" value-format="yyyy-MM-dd hh:mm:ss" type="date" placeholder="请填写签单日期" clearable />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider content-position="left">参与成员</el-divider>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必选项' }]" label="商务" :error="formError.user_affair_id?.toString()" prop="user_affair_id">
                            <users-select v-model="form.user_affair_id" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必选项' }]" label="销售" :error="formError.user_sale_id?.toString()" prop="user_sale_id">
                            <users-select v-model="form.user_sale_id" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必选项' }]" label="售前" :error="formError.user_presale_id?.toString()" prop="user_presale_id">
                            <users-select v-model="form.user_presale_id" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必选项' }]" label="管理员" :error="formError.user_admin_id?.toString()" prop="user_admin_id">
                            <users-select v-model="form.user_admin_id" disabled />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider content-position="left">成本预估</el-divider>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="预估总成本" :error="formError.estimate_money?.toString()" prop="estimate_money">
                            <el-input-number v-model="form.estimate_money" :min="0" :precision="2" disabled class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="预估工时" :error="formError.estimate_work_day?.toString()" prop="estimate_work_day">
                            <el-input-number v-model="form.estimate_work_day" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="人工成本" :error="formError.estimate_labor?.toString()" prop="estimate_labor">
                            <el-input-number v-model="form.estimate_labor" :min="0" :precision="2" disabled class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>      
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="采购金额" :error="formError.estimate_procurement?.toString()" prop="estimate_procurement">
                            <el-input-number v-model="form.estimate_procurement" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="外采金额" :error="formError.sign_money_sw?.toString()" prop="sign_money_sw">
                            <el-input-number v-model="form.sign_money_sw" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="驻点费用" :error="formError.estimate_stationing?.toString()" prop="estimate_stationing">
                            <el-input-number v-model="form.estimate_stationing" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="其他金额" :error="formError.estimate_other?.toString()" prop="estimate_other">
                            <el-input-number v-model="form.estimate_other" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item  
                            :rules="[{ required: true, message: '必填项' }]" 
                            label="税率 / %" 
                            :error="formError.taxation_rate?.toString()" 
                            prop="taxation_rate">
                            <el-select v-model="form.taxation_rate" placeholder="请选择税率" class="w-width-auto">
                                <el-option label="0" :value="0"></el-option>
                                <el-option label="1" :value="1"></el-option>
                                <el-option label="3" :value="3"></el-option>
                                <el-option label="6" :value="6"></el-option>
                                <el-option label="9" :value="9"></el-option>
                                <el-option label="13" :value="13"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="税金" :error="formError.taxation_money?.toString()" prop="taxation_money">
                            <el-input-number v-model="form.taxation_money" :min="0" :precision="2" disabled class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider content-position="left">签单金额</el-divider>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="合同总金额" :error="formError.sign_money?.toString()" prop="sign_money">
                            <el-input-number v-model="form.sign_money" :min="0" :precision="2" disabled class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="开发金额" :error="formError.sign_money_kf?.toString()" prop="sign_money_kf">
                            <el-input-number v-model="form.sign_money_kf" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="集成金额" :error="formError.sign_money_jc?.toString()" prop="sign_money_jc">
                            <el-input-number v-model="form.sign_money_jc" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="运维金额" :error="formError.sign_money_yw?.toString()" prop="sign_money_yw">
                            <el-input-number v-model="form.sign_money_yw" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="安服金额" :error="formError.sign_money_af?.toString()" prop="sign_money_af">
                            <el-input-number v-model="form.sign_money_af" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="工程金额" :error="formError.sign_money_gc?.toString()" prop="sign_money_gc">
                            <el-input-number v-model="form.sign_money_gc" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="设备金额" :error="formError.sign_money_sb?.toString()" prop="sign_money_sb">
                            <el-input-number v-model="form.sign_money_sb" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="过单金额" :error="formError.sign_money_gd?.toString()" prop="sign_money_gd">
                            <el-input-number v-model="form.sign_money_gd" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="其它金额" :error="formError.sign_money_qt?.toString()" prop="sign_money_qt">
                            <el-input-number v-model="form.sign_money_qt" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
                        <el-form-item :rules="[{ required: true, message: '必填项' }]" label="外采金额" :error="formError.sign_money_sw?.toString()" prop="sign_money_sw">
                            <el-input-number v-model="form.sign_money_sw" :min="0" :precision="2" class="w-width-auto"></el-input-number>
                        </el-form-item>
                    </el-col> -->
                </el-row>
                <el-divider content-position="left">其它信息</el-divider>
                <el-form-item label="合同描述" >
                    <froala-editor v-model="form.describe" />
                </el-form-item>
                <el-form-item label="审批流程">
                    <workflow-update ref="workflow" v-model="form.workflow_template" model="contract" init />
                </el-form-item>
                <el-form-item label="附件">
                    <files-upload v-model="form.files_id" model="contract" stage="创建合同" />
                </el-form-item>
            </el-form>
        </div>
        <div class="w-el-drawer-footer">
            <el-button size="medium" @click="Close()">取消 / 返回</el-button>
            <el-button size="medium" type="info" @click="ContractCreate(true)" :loading="loading">存为草稿</el-button>
            <el-button size="medium" type="primary" @click="ContractCreate(false)" :loading="loading">创建合同</el-button>
        </div>
    </el-drawer>
</template>
<script>
import inputSource from "@/views/config/contractSource/input"
export default {
    components: {
        inputSource
    },
    data() {
        return {
                        visible: false,
            loading: false,
                        formError: {},
            form: {
                sale_documentary_id: null,
                customer_id: null,
                name: null,
                number: null,
                source_id: null,
                state: null,
                time_limit: null,
                sign_date: null,
                sign_money: 0,
                sign_money_jc: 0,
                sign_money_yw: 0,
                sign_money_af: 0,
                sign_money_gc: 0,
                sign_money_sb: 0,
                sign_money_kf: 0,
                sign_money_gd: 0,
                sign_money_qt: 0,
                sign_money_sw: 0,
                estimate_money: 0,
                estimate_work_day: 0,
                estimate_labor: 0,
                estimate_procurement:  0,
                estimate_stationing: 0,
                estimate_other: 0,
                taxation_rate: 0,
                taxation_money: 0,
                user_affair_id: null,
                user_sale_id: null,
                user_presale_id: null,
                user_admin_id: null,    
                describe: null,
                files_id: [],
                workflow_template: null,
                draft: 0,
            },
        }
    },
    watch: {
        'form.sign_money_jc' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_yw' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_af' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_gc' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_sb' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_kf' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_gd' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money_qt' () { this.form.sign_money = this.form.sign_money_jc + this.form.sign_money_yw + this.form.sign_money_af + this.form.sign_money_gc + this.form.sign_money_sb + this.form.sign_money_kf + this.form.sign_money_gd + this.form.sign_money_qt },
        'form.sign_money' () {this.CountTaxationRate()},  

        'form.estimate_procurement' () { this.CountTaxationRate(), this.form.estimate_money = this.form.estimate_procurement + this.form.sign_money_sw + this.form.estimate_stationing + this.form.estimate_other + this.form.taxation_money + this.form.estimate_labor},
        'form.sign_money_sw' () { this.form.estimate_money = this.form.estimate_procurement + this.form.sign_money_sw + this.form.estimate_stationing + this.form.estimate_other + this.form.taxation_money + this.form.estimate_labor},
        'form.estimate_stationing' () { this.form.estimate_money = this.form.estimate_procurement + this.form.sign_money_sw + this.form.estimate_stationing + this.form.estimate_other + this.form.taxation_money + this.form.estimate_labor},
        'form.estimate_other' () { this.form.estimate_money = this.form.estimate_procurement + this.form.sign_money_sw + this.form.estimate_stationing + this.form.estimate_other + this.form.taxation_money + this.form.estimate_labor},
        'form.estimate_labor' () { this.form.estimate_money = this.form.estimate_procurement + this.form.sign_money_sw + this.form.estimate_stationing + this.form.estimate_other + this.form.taxation_money + this.form.estimate_labor},
        'form.taxation_money' () { this.form.estimate_money = this.form.estimate_procurement + this.form.sign_money_sw + this.form.estimate_stationing + this.form.estimate_other + this.form.taxation_money + this.form.estimate_labor},
        'form.taxation_rate' () {this.CountTaxationRate()},
        'form.estimate_work_day' () { this.form.estimate_labor = this.form.estimate_work_day * 550},
    },
    methods: {
        Open() {
            this.visible = true
            this.loading = false
            this.formError = {}
            this.form.sale_documentary_id = null
            this.form.customer_id = null
            this.form.name = null
            this.form.number = null
            this.form.source_id = null
            this.form.state = null
            this.form.time_limit = null
            this.form.sign_date = null
            this.form.sign_money = 0
            this.form.sign_money_jc = 0
            this.form.sign_money_yw = 0
            this.form.sign_money_af = 0
            this.form.sign_money_gc = 0
            this.form.sign_money_sb = 0
            this.form.sign_money_kf = 0
            this.form.sign_money_gd = 0
            this.form.sign_money_qt = 0
            this.form.sign_money_sw = 0
            this.form.estimate_money = 0
            this.form.estimate_work_day = 0
            this.form.estimate_labor = 0
            this.form.estimate_procurement = 0
            this.form.estimate_stationing = 0
            this.form.estimate_other = 0
            this.form.taxation_rate = 0
            this.form.taxation_money = 0
            this.form.user_affair_id = null
            this.form.user_sale_id = null
            this.form.user_presale_id = null
            this.form.user_admin_id = this.$store.state.user.id
            this.form.describe = null
            this.form.files_id = []
            this.form.workflow_template = null
            this.form.draft = 0
            this.$http.post('/9api/workflow/template', { model: 'contract-workflow' }).then(rps => {
                this.form.workflow_template = rps.data.template
            })
        },
        Close() {
            this.visible = false
            this.loading = false
        },
        ContractCreate(draft) {
            this.form.draft = draft ? 1 : 0;
                        this.loading = true
            this.formError = {}
                        this.$http.post('/9api/contract/create', this.form).then(rps => {
                this.loading = false
                                if (rps.data.status == 'error') {
                    this.formError = rps.data.error
                }
                                if (rps.data.status == 'success') {
                                        this.$notify.success({ title: '提示', message: '合同添加成功', duration: 2000 })
                    this.contract = rps.data.body
                    this.$emit('onSave', this.contract)
                    this.Close()
                }
            })
        },
        SaleDocumentaryOnChange(data) {
            this.form.customer_id = data?.customer_id
            this.form.name = data?.name
            this.form.source_id = data?.source_id
            this.form.sign_money = data?.sign_money
            this.form.sign_money_jc = data?.sign_money_jc
            this.form.sign_money_yw = data?.sign_money_yw
            this.form.sign_money_af = data?.sign_money_af
            this.form.sign_money_gc = data?.sign_money_gc
            this.form.sign_money_sb = data?.sign_money_sb
            this.form.sign_money_kf = data?.sign_money_kf
            this.form.sign_money_gd = data?.sign_money_gd
            this.form.sign_money_qt = data?.sign_money_qt
            this.form.sign_money_sw = data?.sign_money_sw
            this.form.estimate_money = data?.estimate_money
            this.form.estimate_work_day = data?.estimate_work_day
            this.form.estimate_labor = data?.estimate_labor
            this.form.estimate_procurement = data?.estimate_procurement
            this.form.estimate_stationing = data?.estimate_stationing
            this.form.estimate_other = data?.estimate_other
            this.form.taxation_rate = data?.taxation_rate
            this.form.taxation_money = data?.taxation_money
            this.form.user_affair_id = data?.user_affair_id
            this.form.user_sale_id = data?.user_sale_id
            this.form.user_presale_id = data?.user_presale_id
            this.form.files_id = data?.files_id
        },

        // 计算税金 mos+
        CountTaxationRate(){
            // (项目预期总金额-采购成本) / (1+税率) * 税率 * 1.12 + (项目预期总金额+采购成本) * 0.0003
            //注：1%的税率等于数字0.01 、 0.0003 = 0.03% （印花税）
            if(['1.00','3.00'].includes(this.form.taxation_rate)){
              this.form.taxation_money = (this.form.sign_money-this.form.estimate_procurement) / (1 + this.form.taxation_rate * 0.01) * (this.form.taxation_rate * 0.01) * 1.12 + (this.form.sign_money+this.form.estimate_procurement) * 0.0003
            }else if(['6.00','9.00','13.00'].includes(this.form.taxation_rate)){
              this.form.taxation_money = (this.form.sign_money-this.form.estimate_procurement) / (1 + this.form.taxation_rate * 0.01) * (this.form.taxation_rate * 0.01) * 1.12 + (this.form.sign_money+this.form.estimate_procurement) * 0.0003
            }else{
              this.form.taxation_money = (this.form.sign_money-this.form.estimate_procurement) / (1 + this.form.taxation_rate * 0.01) * (this.form.taxation_rate * 0.01) * 1.12 + (this.form.sign_money+this.form.estimate_procurement) * 0.0003
            }
        }
    }
}
</script>